mutation NoteSupplierCreate($input: NoteSupplierCreateInput!) {
  noteSupplierCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
